import React, { useState } from "react";
import { useLocation } from "react-router";
import { Breadcrumbs, InnoTable, Popover, TableList } from "InnoUI/components";
import InnoIcons from "InnoUI/innoicons";
import SC from "./style";
import theme from "theme";

const AuthorizationRequests = (props) => {
  const { popupState } = props;
  const location = useLocation();
  const currentPath = location.pathname;

  const breadcrumbItems = [
    { label: "Admin Settings" },
    {
      label: "Authorization Requests",
      href: "/admin-settings/authorization-requests",
    },
  ];

  const menuItems = [
    {
      id: 1,
      text: "Edit",
      // icon: <InnoIcons.BackupTableIcon />,
      onClick: () => alert("true"),
    },
    {
      id: 2,
      text: "Assign Projects",
      // icon: <InnoIcons.BackupTableIcon />,
      onClick: () => alert("true"),
    },
    {
      id: 3,
      text: "Assign Roles",
      // icon: <InnoIcons.BackupTableIcon />,
      onClick: () => alert("true"),
    },
    {
      id: 4,
      text: "Send Credentials",
      // icon: <InnoIcons.BackupTableIcon />,
      onClick: () => alert("true"),
    },
    {
      id: 5,
      text: "Delete",
      // icon: <InnoIcons.BackupTableIcon />,
      onClick: () => alert("true"),
    },
  ];

  const subColumnData = [
    {
      title: "Full Name",
      dataIndex: "user_name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      showSorterTooltip: { target: "sorter-icon" },
      sortDirections: ["ascend", "descend"],
      width: 350,
      onCell: () => ({}),
      render(value, record) {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span style={{ color: "black", opacity: "0.7" }}>{value}</span>
            <span style={{ backgroundColor: "#f3f3f3" }}>
              <Popover
                sx={{
                  cursor: "pointer",
                }}
                buttonLabel={{
                  icon: (
                    <InnoIcons.MoreVertIcon
                      sx={{
                        fontSize: "15px",
                        margin: "5px 0px 5px 0px",
                        backgroundColor: "#f3f3f3",
                        cursor: "pointer",
                      }}
                    />
                  ),
                }}
                popoverContent={
                  <TableList
                    sx={{
                      borderBottom: `1px solid ${theme.colors.bordertask}`,
                    }}
                    items={menuItems || []}
                    popupState={popupState}
                  />
                }
              />
            </span>
          </div>
        );
      },
    },

    {
      title: "Email",
      dataIndex: "full_name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      showSorterTooltip: { target: "sorter-icon" },
      sortDirections: ["ascend", "descend"],
      width: 350,

      onCell: () => ({}),
      render(value, record) {
        return (
          <>
            <span style={{ color: "black", opacity: "0.7" }}>{value}</span>
          </>
        );
      },
    },

    {
      title: "Cell",
      dataIndex: "cell_number",
      width: 300,

      onCell: () => ({}),
      render(value, record) {
        return (
          <>
            <span style={{ color: "black", opacity: "0.7" }}>{value}</span>
          </>
        );
      },
    },
    {
      title: "Account Status",
      dataIndex: "company_Name",
      width: 250,

      onCell: () => ({}),
      render(value, record) {
        return (
          <>
            <span style={{ color: "black", opacity: "0.7" }}>{value}</span>
          </>
        );
      },
    },
    {
      title: "Authorization Status",
      dataIndex: "email",
      onCell: () => ({
        style: { width: "350px" },
      }),
      render(value, record) {
        return (
          <>
            <span style={{ color: "black", opacity: "0.7" }}>{value}</span>
          </>
        );
      },
    },
  ];
  const tableConfig = {
    draggable: false,
    selection: false,
    expandable: true,
    addNew: false,
    search: true,
    action: false,
    divBorder: true,
    sno: true,
  };

  return (
    <>
      <Breadcrumbs
        items={breadcrumbItems}
        separator=">"
        currentPath={currentPath}
        onClick={() => alert("clicked")}
      />
      <SC.BodyContainer>
        <SC.Container>
          <InnoTable
            tableConfig={tableConfig}
            padding={"8px 8px 8px 8px"}
            column={subColumnData}
            data={[]}
            tableKey={"User"}
            ComponnentName={"Authorization Requests"}
          />
        </SC.Container>
      </SC.BodyContainer>
    </>
  );
};

export default AuthorizationRequests;
